import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { RulesetResult } from '../../business/rules';
import { BankStatementsLastMonthRuleset } from '../../business/ruleset';

const {
  formField: {
    documents: { bankStatementLastMonth },
  },
} = loanFormModel;

export class BankStatementsLastMonthValidation implements ValidationSchema {
  public name: string = bankStatementLastMonth.name;
  public label: string = bankStatementLastMonth.label;
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = BankStatementsLastMonthRuleset;

  public when(schema: any, context: any, rulesetResult: RulesetResult) {
    const required = !!(rulesetResult & RulesetResult.REQUIRED);
    const fileSchema = FileNameValidationSchema(
      bankStatementLastMonth.name,
      required
    );
    if (required) {
      return fileSchema.required('This document is required');
    }
    return fileSchema;
  }
}
export default new Validation(new BankStatementsLastMonthValidation());
